import permissions from '../utils/permissionsUtils';
import {isMobileDevice} from '../utils/generalUtils';
import {AccountStatus} from "../utils/enumUtils";

const initialState = {
    loggingIn: false,
    loggingOut: false,
    loggedIn: false,
    error: null,
    data: {},
    changesSaved: false,
    fetched: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case "LOGIN_PENDING":
        case "RESTORE_SESSION_PENDING":
        case "REGISTER_PENDING":   {
            return {
                ...state,
                loggingIn: true,
                error: null}
        }
        case "LOGIN_REJECTED":
        case "RESTORE_SESSION_REJECTED":
        case "REGISTER_REJECTED":   {
            return {...state, loggingIn: false, error: action.payload}
        }
        case "LOGIN_FULFILLED":
        case "RESTORE_SESSION_FULFILLED":
        case "REGISTER_FULFILLED": {
            if (!isMobileDevice()) {
                localStorage.setItem("viboLastLogin", action.payload.data.objectId);
                return getAfterSuccessfulLoginState(state, action.payload);
            }
            break;
        }

        case "EDIT_USER_INFO_PENDING": {
            return {
                ...state,
                changesSaved: false,
                fetched: false,
            }
        }
        case "EDIT_USER_INFO_REJECTED": {
            return {...state, error: action.payload, fetched: true, changesSaved: false}
        }
        case "EDIT_USER_INFO_FULFILLED": {
            return {
                ...state,
                data: getUserData(action.payload.data),
                fetched: true,
                changesSaved: true,
            }
        }
        case "SET_SCANNER_TEST_MODE_FULFILLED": {
            return {
                ...state,
                data: getUserData(action.payload.data),
            }
        }
        case "EDIT_PICTURE_USER_FULFILLED": {
            return {
                ...state,
                data: {
                    ...state.data,
                    picUrl: action.payload.data.picUrl,
                    coverPicUrl: action.payload.data.coverPicUrl,
                    logoPicUrl: action.payload.data.logoPicUrl,
                },
                fetched: true,
                changesSaved: true,
            }
        }

        case 'ADD_IMAGE_TO_USER_GALLERY_PENDING' : {
            return {
                ...state,
                fetching: true,
                fetched: false,
            }
        }
        case 'ADD_IMAGE_TO_USER_GALLERY_REJECTED' : {
            return {
                ...state,
                fetching: false,
                fetched: false,
            }
        }
        case 'ADD_IMAGE_TO_USER_GALLERY_FULFILLED' : {
            return {
                ...state,
                fetched: true,
                imageUrl: action.payload.data,
            }
        }

        case 'SAVE_PIC_TYPE_TO_EDIT' : {
            return {
                ...state,
                picType: action.payload,
            }
        }

        case "PLACE_PAYMENT_TO_VIBO_FULFILLED":{
            return {
                ...state,
                data: {
                    ...state.data,
                    account: action.payload.data.accountData
                }
            }
        }

        case "CHECK_COUPON_FULFILLED":{
            return {
                ...state,
                data: {
                    ...state.data,
                    coupon: action.payload.data.couponData
                }
            }
        }

        default:
            return state
    }
}

function getAfterSuccessfulLoginState(state, payload) {
    permissions.setUserRole(payload.data.role);
    return {
        ...state,
        loggingIn: false,
        loggedIn: true,
        data: getUserData(payload.data)
    }
}
function getUserData(userData) {
    let subUsers = userData.subUsers || [];
    return {
        id                      : userData.objectId,
        objectId                : userData.objectId,
        username                : userData.username,
        fullName                : userData.fullName,
        nickName                : userData.nickName,
        companyName             : userData.companyName,
        email                   : userData.email,
        emailActually           : userData.emailActually,
        picUrl                  : userData.picUrl,
        coverPicUrl             : userData.coverPicUrl,
        logoPicUrl              : userData.logoPicUrl,
        aboutText               : userData.aboutText,
        phoneNumber             : userData.phoneNumber,
        webPage                 : userData.webPage,
        fb_page                 : userData.fb_page,
        youtube                 : userData.youtube,
        instagram               : userData.instagram,
        region                  : userData.region,
        role                    : userData.role,
        isDJ                    : userData.isDJ,
        subUsers                : subUsers,
        allUsers                :[{id:userData.objectId, fullName:userData.fullName}].concat(subUsers),
        uploadedFilesData       : userData.uploadedFilesData,
        uploadedFilesDataTest   : userData.uploadedFilesDataTest,
        account                 : userData.accountData || {status: AccountStatus.LIMITED},
        eventDetailsHook        : userData.eventDetailsHook,
    }
}



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js